'use strict';

import angular from 'angular';

/**
 * Filtre range - génère une séquence de nombres pour la pagination
 * 
 * Usage: [] | range:min:max
 * Exemple: [] | range:1:10 => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
 */
angular.module('observatoireApp')
  .filter('range', function() {
    return function(input, min, max) {
      min = parseInt(min, 10);
      max = parseInt(max, 10);
      
      // Protection contre les valeurs NaN ou invalides
      if (isNaN(min)) min = 0;
      if (isNaN(max)) max = 0;
      
      // Si les valeurs sont incohérentes, retourner un tableau vide
      if (min > max) return [];
      
      // Pour éviter les boucles infinies ou trop grandes
      if (max - min > 1000) max = min + 1000;
      
      // Créer la séquence de nombres
      for (var i = min; i <= max; i++) {
        input.push(i);
      }
      
      return input;
    };
  });
